module.exports = __webpack_public_path__ + "img/greetingsBg.911b4e4c.svg";